import { Typography } from "@mui/material";
import { useContext } from "react";
import { useLoaderData, useParams } from "react-router-dom";

import ClientDetailProvider from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/context/ClientDetailContext";
import PermissionWrapper from "../../../../../components/global/PermissionWrapper";
import Appointments from "../../../../../components/modules/appointments/Appointments";
import Navigation from "../../../../../components/navigations/medical-records/cases/detail/navigation";
import DataContext from "../../../../../context/DataContext";

export default function () {
  const { userRoles } = useContext(DataContext);

  const { _case } = useLoaderData();

  const params = useParams();

  const permissionAppointments = userRoles.permissions.includes("provider.view_appointment");

  if (params.id) {
    return (
      <Navigation activeTab="appointments" _case={_case}>
        <ClientDetailProvider>
          <div className="pt-6">
            {permissionAppointments ? (
              <PermissionWrapper permission={permissionAppointments}>
                <Appointments caseInfo={_case} />
              </PermissionWrapper>
            ) : (
              <Typography className="text-center text-gray-500">Nothing to show</Typography>
            )}
          </div>
        </ClientDetailProvider>
      </Navigation>
    );
  }
}
